import { ButtonGroup, Grid, InputLabel } from '@mui/material';
import React from 'react';
import { ButtonCheck, ButtonEmptyCheck } from './mini_components';

interface MultioptionProps {
    label:string,
    mode:"show" | "input",
    value:{"multioption" : string}[],
    name:string,
    options?:{label:string, value:string}[],
    multiOptionSelected: (value: string) => void;
}

const Multioption: React.FC<MultioptionProps> = ({ label, mode, name, value, options, multiOptionSelected }) => {
    // SHER-208: when rendered for an orphan record (its surveyField is no longer in the
    // active section), `options` is undefined because the section schema does not carry
    // inactive fields. Fall back to deriving labels from the recorded values so the user
    // still sees what was selected instead of crashing on options.map().
    const safeValue = Array.isArray(value) ? value : [];
    const safeOptions = Array.isArray(options) && options.length > 0
        ? options
        : safeValue.map(v => ({ label: v?.multioption ?? '', value: v?.multioption ?? '' }));
    const optionButtons = safeOptions.map(option => {
        if(safeValue.length > 0 &&  safeValue.find((selection) => selection.multioption === option.value)){
            return <ButtonCheck  onClick={mode === "show" ?  undefined : () => multiOptionSelected(option.value)}>{option.label}</ButtonCheck>
        }
        return <ButtonEmptyCheck onClick={mode === "show" ? undefined : () => multiOptionSelected(option.value) }>{option.label}</ButtonEmptyCheck>
    });
    console.log("optionButtons",safeValue);
    return (
        <Grid container style={{paddingTop:'0.5rem'}}>
        {
            !label.includes("general.") &&
            <Grid item  xs={12}>
                <InputLabel id={name}>{label}</InputLabel>
            </Grid>
        }
        <Grid item  xs={12}>
            <ButtonGroup color="primary" aria-label="outlined primary button group" style={{flexWrap: "wrap"}}>
                {optionButtons}
            </ButtonGroup>
        </Grid>
    </Grid>
    );
};

export default Multioption;
